import ActionsForm from '@/shared/mixins/actionsForm'
import EnterpriseAccreditedRepository from '@/shared/http/repositories/realestate/enterpriseaccredited'
import { toast, loading } from '@/shared/utils/UIHelper'
export default {
  name: 'Toaddenterprise',
  mixins: [ActionsForm],
  props: ['id'],
  data () {
    return {
      empreedimentoId: '',
      enterprise: []
    }
  },
  mounted () {
    this.getenterprise()
  },
  methods: {
    show () {
      this.$refs['add-enterprise-modal'].show()
      this.getenterprise()
      this.empreedimentoId = ''
    },

    cancelNewEnterprise (e) {
      e.preventDefault()
      this.$refs['add-enterprise-modal'].hide()
      Object.keys(this.newEnterpriseData).forEach(key => {
        if (key === 'dateBirth') {
          this.newEnterpriseData[key] = null
        } else {
          this.newEnterpriseData[key] = ''
        }
      })
    },
    getenterprise () {
      EnterpriseAccreditedRepository.GetUnboundEnterprises(this.id)
        .then((res) => {
          // Limpa o array antes de adicionar os novos dados
          this.enterprise = []
          let stateCompleteData = res.data.data
          stateCompleteData.forEach(stateData => {
            this.enterprise.push({ value: stateData.id, text: stateData.nome })
          })
        })
        .catch(() => {})
    },

    onSubmit (e) {
      loading.push()
      EnterpriseAccreditedRepository.PostEmpreendimentoCredenciada(this.empreedimentoId, this.id)
        .then(res => {
          if (res.status === 200) {
            this.$refs['add-enterprise-modal'].hide()
            this.$emit('getAllEnterpriseByAccredited')
            toast.success(`Empreendimento adicionado com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao adicionar o empreedimento`)
          loading.pop()
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/toaddenterprise/toaddenterprise.js